import script from "./errorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./errorModal.vue?vue&type=script&setup=true&lang=js"

import "./errorModal.vue?vue&type=style&index=0&id=7e50871e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e50871e"]])

export default __exports__